import {
    build_case_form_sections,
    build_questionnaire_answers,
    build_transition_stage_timeline,
    build_summary_rows
} from "@/services/onboarding_journey_service";

export function build_summary_state(case_item = {}, options = {}) {
    const summary_state = {
        summary_rows: build_summary_rows(case_item),
        summary_stage_timeline: build_transition_stage_timeline(
            case_item,
            options?.transition_history || [],
            options?.configured_gate_ids || []
        ),
        summary_case_form_sections: build_case_form_sections(case_item)
    };
    return summary_state;
}

export function build_historical_questionnaire_answers(case_item = {}) {
    const questionnaire_answers = Array.isArray(case_item?.questionnaire_answers) && case_item.questionnaire_answers.length
        ? case_item.questionnaire_answers
        : build_questionnaire_answers(case_item);
    return questionnaire_answers.map(normalize_historical_risk_answer);
}

export function has_saved_signer_configuration(vm) {
    return Boolean(
        vm.signer_configuration_summary?.workflow_assignment_id
        && Array.isArray(vm.signer_configuration_summary?.signers)
        && vm.signer_configuration_summary.signers.length
    );
}

export function get_step_navigation_rule(vm, step_number) {
    const step_rules = {
        1: true,
        2: Boolean(vm.selected_template),
        3: has_saved_signer_configuration(vm) || vm.current_request_step === 2
    };
    return Boolean(Reflect.get(step_rules, step_number));
}

export function should_skip_request_step_navigation(vm, step_number) {
    return step_number === vm.current_request_step || !vm.can_navigate_to_step(step_number);
}

export function should_save_signers_before_review(vm) {
    return vm.current_request_step === 2 && !has_saved_signer_configuration(vm);
}

function get_first_text(values = [], fallback = "-") {
    const value = values.find((candidate) => candidate !== undefined && candidate !== null && String(candidate).trim() !== "");
    return value === undefined ? fallback : String(value);
}

function normalize_historical_risk_answer(answer = {}, index = 0) {
    return {
        id: Number(answer?.question_id || answer?.id || index + 1),
        label: get_first_text([
            answer?.question_text,
            answer?.question,
            answer?.label,
            answer?.name
        ], "Risk question"),
        selected_answer: get_first_text([
            answer?.answer,
            answer?.display_value,
            answer?.value,
            answer?.response
        ], "Not answered")
    };
}
